<div *ngIf='sessionData' class='PrefsPipeline'>
  <div class='container'>
    <div class='PrefsPipeline-header d-flex flex-row'>
      <div class='flex-grow-1'>
        <h4>Create Pipeline</h4>
      </div>
      <div class='flex-grow-0'>
        <a [routerLink]="['/messages']">Back to Inbox</a>
      </div>
    </div>
    <div class='PrefsPipeline-info d-flex flex-row'>
      <div class='flex-grow-1'>
        <p>
          Retreva&reg; offers a basic Pipeline feature to help keep your
          meetings on track. Would you like to use the Pipeline feature
        </p>
        <app-info-tip-button [type]="'pipeline_feature'"></app-info-tip-button>
      </div>
      <div class='flex-grow-0'>
        <app-button
          [Click]='yesButtonProperties.onClick'
          [color]='yesButtonProperties.color'
          [size]='yesButtonProperties.size'
          [text]='yesButtonProperties.text'
          class='PrefsPipeline-form-button'></app-button>
        <app-button
          [Click]='noButtonProperties.onClick'
          [color]='noButtonProperties.color'
          [size]='noButtonProperties.size'
          [text]='noButtonProperties.text'
          class='PrefsPipeline-form-button'></app-button>
      </div>
    </div>
    <div class='PrefsPipeline-form container'>
      <form [formGroup]='formGroup'>
        <div class='row'>
          <div class='PrefsPipeline-form-label col col-12 col-md-6'>
            <p class='mb-0'>Step 1</p>
          </div>
          <div class='col col-12 col-md-6'>
            <mat-form-field>
              <input formControlName='label1' matInput name='label1' />
            </mat-form-field>
          </div>
        </div>
        <div class='row'>
          <div class='PrefsPipeline-form-label col col-12 col-md-6'>
            <p class='mb-0'>Step 2</p>
          </div>
          <div class='col col-12 col-md-6'>
            <mat-form-field>
              <input formControlName='label2' matInput name='label2' />
            </mat-form-field>
          </div>
        </div>
        <div class='row'>
          <div class='PrefsPipeline-form-label col col-12 col-md-6'>
            <p class='mb-0'>Step 3</p>
          </div>
          <div class='col col-12 col-md-6'>
            <mat-form-field>
              <input formControlName='label3' matInput name='label3' />
            </mat-form-field>
          </div>
        </div>
        <div class='row'>
          <div class='PrefsPipeline-form-label col col-12 col-md-6'>
            <p class='mb-0'>Step 4</p>
          </div>
          <div class='col col-12 col-md-6'>
            <mat-form-field>
              <input formControlName='label4' matInput name='label4' />
            </mat-form-field>
          </div>
        </div>
        <div class='row'>
          <div class='PrefsPipeline-form-label col col-12 col-md-6'>
            <p class='mb-0'>Step 5</p>
          </div>
          <div class='col col-12 col-md-6'>
            <mat-form-field>
              <input formControlName='label5' matInput name='label5' />
            </mat-form-field>
          </div>
        </div>
        <div class='row'>
          <div class='PrefsPipeline-form-label col col-12 col-md-6'>
            <p class='mb-0'>Step 6</p>
          </div>
          <div class='col col-12 col-md-6'>
            <mat-form-field>
              <input formControlName='label6' matInput name='label6' />
            </mat-form-field>
          </div>
        </div>
        <div class='row'>
          <div class='PrefsPipeline-form-label col col-12 col-md-6'>
            <p class='mb-0'>Step 7</p>
          </div>
          <div class='col col-12 col-md-6'>
            <mat-form-field>
              <input formControlName='label7' matInput name='label7' />
            </mat-form-field>
          </div>
        </div>
        <div class='row'>
          <div class='PrefsPipeline-form-label col col-12 col-md-6'>
            <p class='mb-0'>Step 8</p>
          </div>
          <div class='col col-12 col-md-6'>
            <mat-form-field>
              <input formControlName='label8' matInput name='label8' />
            </mat-form-field>
          </div>
        </div>
        <div class='row'>
          <div class='PrefsPipeline-form-label col col-12 col-md-6'>
            <p class='mb-0'>Step 9</p>
          </div>
          <div class='col col-12 col-md-6'>
            <mat-form-field>
              <input formControlName='label9' matInput name='label9' />
            </mat-form-field>
          </div>
        </div>
        <div class='row'>
          <div class='PrefsPipeline-form-label col col-12 col-md-6'>
            <p class='mb-0'>Step 10</p>
          </div>
          <div class='col col-12 col-md-6'>
            <mat-form-field>
              <input formControlName='label10' matInput name='label10' />
            </mat-form-field>
          </div>
        </div>
        <div class='row'>
          <div class='col col-12 col-md-6 offset-0 offset-md-6'>
            <app-button
              [color]='cancelButtonProperties.color'
              [route]='cancelButtonProperties.route'
              [size]='cancelButtonProperties.size'
              [text]='cancelButtonProperties.text'
              class='PrefsPipeline-form-button'></app-button>
            <app-button
              [Click]='finishButtonProperties.onClick'
              [color]='finishButtonProperties.color'
              [size]='finishButtonProperties.size'
              [text]='finishButtonProperties.text'
              class='PrefsPipeline-form-button'></app-button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
